import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import {
  WebinarCardWrapper,
  WebinarCardImage,
  WebinarCardImageImg,
  WebinarCardTag,
  WebinarCardContent,
  WebinarCardTitle,
  WebinarCardCta,
} from './WebinarPageStyles'

const TAGS = { popular: 'Popular', trending: 'Trending' }

export function WebinarCard({ item, tagType, onClick }) {
  const imageSrc = getImageLink(item?.imageId)

  return (
    <WebinarCardWrapper onClick={() => onClick?.(item)} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && onClick?.(item)}>
      <WebinarCardImage>
        <WebinarCardImageImg src={imageSrc} alt={item?.title} loading="lazy" />
        {tagType && (
          <WebinarCardTag className={tagType}>{TAGS[tagType]}</WebinarCardTag>
        )}
      </WebinarCardImage>
      <WebinarCardContent>
        <WebinarCardTitle>{item?.title}</WebinarCardTitle>
        <WebinarCardCta>View details →</WebinarCardCta>
      </WebinarCardContent>
    </WebinarCardWrapper>
  )
}
